var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "620px",
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.feeName"),
                        prop: "feeItem",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t("feeTab.feeName"),
                          "option-list": _vm.feeNameOptions,
                        },
                        model: {
                          value: _vm.form.feeItem,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "feeItem", $$v)
                          },
                          expression: "form.feeItem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.settlementParty"),
                        prop: "cusId",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t("feeTab.settlementParty"),
                          "option-list": _vm.settlementPartyOptions,
                        },
                        model: {
                          value: _vm.form.cusId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cusId", $$v)
                          },
                          expression: "form.cusId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.billingUnit"),
                        prop: "chargeUnit",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t("feeTab.billingUnit"),
                          "option-list": _vm.chargeUnitOptions,
                        },
                        model: {
                          value: _vm.form.chargeUnit,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "chargeUnit", $$v)
                          },
                          expression: "form.chargeUnit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.settlementCurrency"),
                        prop: "quotationCurrency",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          placeholder: _vm.$t("feeTab.settlementCurrency"),
                          "option-list": _vm.currencyOptions,
                        },
                        model: {
                          value: _vm.form.quotationCurrency,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "quotationCurrency", $$v)
                          },
                          expression: "form.quotationCurrency",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.settlementUnitPrice"),
                        prop: "unitPrice",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "full-width",
                        attrs: {
                          placeholder: _vm.$t("feeTab.settlementUnitPrice"),
                          controls: false,
                          precision: 4,
                          step: 0.0001,
                          min: 0.0001,
                          max: 999999.9999,
                        },
                        model: {
                          value: _vm.form.unitPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "unitPrice", $$v)
                          },
                          expression: "form.unitPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.quantity"),
                        prop: "settlementNum",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "full-width",
                        attrs: {
                          placeholder: _vm.$t("feeTab.quantity"),
                          controls: false,
                          precision: 3,
                          step: 0.001,
                          min: 0.001,
                          max: 99999.999,
                        },
                        model: {
                          value: _vm.form.settlementNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "settlementNum", $$v)
                          },
                          expression: "form.settlementNum",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.trackingNumber"),
                        prop: "trackingNumber",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 20,
                          "show-word-limit": "",
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.trackingNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "trackingNumber",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.trackingNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("feeTab.packageNo"),
                        prop: "packageNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 20,
                          "show-word-limit": "",
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.packageNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "packageNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.packageNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("feeTab.remark"), prop: "remark" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          maxlength: 500,
                          "show-word-limit": "",
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "remark",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.handleSave },
            },
            [_vm._v(_vm._s(_vm.$t("saveText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }